<div class="prize_description">
  <div class="prize_description__root">
    <div class="prize_description__title">
      <p class="two-lines">{{ title }}</p>
    </div>
    <div class="prize_description__image">
      <picture>
        <img *ngIf="imgUrl" [src]="imgUrl" alt="Tournament prize image" lazy />
      </picture>
    </div>
    <div class="prize_description__content">
      {{ content }}
    </div>
  </div>
</div>
